/**
 * Runtime configuration.
 *
 * In development: CRA reads from .env.development (baseUrl = localhost:3001).
 * In production:  CRA reads from .env.production  (baseUrl = '', apiBaseUrl = '/api/').
 *
 * CRA injects REACT_APP_* variables at build time via process.env.
 */
const config = {
  baseUrl: process.env.REACT_APP_BASE_URL || '',
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || '/api/',
};

export default config;
